import React, { useEffect } from 'react';
import { Card } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import energyApplyImg from '@/assets/images/icon-energyApply@2x.png';
import energyManagementImg from '@/assets/images/icon-energyManagement@2x.png';
import energyPlanImg from '@/assets/images/icon-energyPlan@2x.png';
import extentApplyImg from '@/assets/images/icon-extentApply@2x.png';
import extentPlanImg from '@/assets/images/icon-extentPlan@2x.png';
import lightControlImg from '@/assets/images/icon-lightcontrol@2x.png';
import inspectionTaskImg from '@/assets/images/icon-inspectionTask@2x.png';
import iconRepairTaskImg from '@/assets/images/icon-repairTask@2x.png';
import iconRepairTaskAppImg from '@/assets/images/icon-repairTaskApplication@2x.png';
import energyOverviewImg from '@/assets/images/icon-energyOverview@2x.png';
import alarmImg from '@/assets/images/icon-alarm@2x.png';
import jsaImg from '@/assets/images/icon-JSA@2x.jpg';
import handoverImg from '@/assets/images/icon-handover@2x.jpg';
import takeOverImg from '@/assets/images/icon-takeover@2x.jpg';
import shiftRecordImg from '@/assets/images/icon-shiftrecord@2x.jpg';
import jsaRecordImg from '@/assets/images/icon-JSArecord@2x.jpg';
import { getStaffPermission } from '@/api/energy';

import './index.scss';

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '能源管控';
    getStaffPermission();
  }, []);

  return (
    <div className="main-container">
      <Card title="能源监控" bodyClassName="list-container">
        <div className="item" onClick={() => navigate(`/intelligent-platform/energyOverview`)}>
          <img src={energyOverviewImg} alt="能源概览" width={48} />
          能源概览
        </div>
        <div className="item" onClick={() => navigate(`/intelligent-platform/alarm/record`)}>
          <img src={alarmImg} alt="报警记录看板" width={48} />
          报警记录看板
        </div>
      </Card>
      <Card title="用能管理" bodyClassName="list-container">
        <div className="item" onClick={() => navigate(`/intelligent-platform/energyUse/plan`)}>
          <img src={energyApplyImg} alt="常规用能填报" width={48} />
          常规用能填报
        </div>
        <div className="item" onClick={() => navigate(`/intelligent-platform/energyUse/plan/list`)}>
          <img src={energyPlanImg} alt="常规用能查看" width={48} />
          常规用能查看
        </div>
        <div className="item">
          <img
            src={extentApplyImg}
            alt="延时用能申请"
            width={48}
            onClick={() => navigate(`/intelligent-platform/energyUse/application/add`)}
          />
          延时用能申请
        </div>
        <div className="item" onClick={() => navigate(`/intelligent-platform/energyUse/application`)}>
          <img src={extentPlanImg} alt="延时用能审批" width={48} />
          延时用能审批
        </div>
        <div className="item" onClick={() => navigate(`/intelligent-platform/energyUse/management`)}>
          <img src={energyManagementImg} alt="用能计划" width={48} />
          用能计划
        </div>
      </Card>
      <Card title="控制管理" bodyClassName="list-container">
        <div className="item" onClick={() => navigate(`/intelligent-platform/lighting/control`)}>
          <img src={lightControlImg} alt="照明控制" width={48} />
          照明控制
        </div>
      </Card>
      <Card title="巡检与工单" bodyClassName="list-container">
        <div
          className="item"
          // onClick={() => {
          //   window.location.href = `${window.JXD_MOBILE}/mobile-inspection/task/list`;
          // }}
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/list`;
          }}
        >
          <img src={inspectionTaskImg} alt="巡检任务" width={48} />
          巡检任务
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-order/list`;
          }}
        >
          <img src={iconRepairTaskImg} alt="工单任务" width={48} />
          工单任务
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-order/create`;
          }}
        >
          <img src={iconRepairTaskAppImg} alt="发起工单" width={48} />
          发起工单
        </div>
      </Card>
      <Card title="日常工作" bodyClassName="list-container">
        <div
          className="item"
          // onClick={() => {
          //   window.location.href = `${window.JXD_MOBILE}/mobile-inspection/task/list`;
          // }}
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/jsa/detail`;
          }}
        >
          <img src={jsaImg} alt="JSA" width={48} />
          JSA
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/handover/form`;
          }}
        >
          <img src={handoverImg} alt="交班" width={48} />
          交班
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/handover/list`;
          }}
        >
          <img src={takeOverImg} alt="接班" width={48} />
          接班
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/handover/records`;
          }}
        >
          <img src={shiftRecordImg} alt="交接班记录" width={48} />
          交接班记录
        </div>
        <div
          className="item"
          onClick={() => {
            window.location.href = `${window.location.origin}/mobile-inspection/jsa/list`;
          }}
        >
          <img src={jsaRecordImg} alt="JSA记录" width={48} />
          JSA记录
        </div>
      </Card>
    </div>
  );
};

export default Home;
